import React, { useContext, useEffect } from 'react';
import {
  Drawer,
  Grid,
  List,
  ListItem,
  ListItemText,
  Paper,
} from '@material-ui/core';
import { DataGrid } from '@mui/x-data-grid';
import { useApi } from '@backstage/core-plugin-api';
import BackButton from '../../../../utils/backButton';
import { promptApiRef } from '../../../../../apis/promptManagementApi';
import { PromptContext } from '../../providers/PromptProvider';
import { AuthContext } from '../../../../../providers/AuthProvider';
import { HelpComponent } from '../../../../utils/helpComponent';
import { useStyles } from '../../styles';
import HELP_URL from '../../../../utils/helpLinkConstant';
import SearchBar from '../../common/SearchBar';

export const PromptPromotionActivityLogs = () => {
  const promptContext = useContext(PromptContext);
  const classes = useStyles();
  const authContext = useContext(AuthContext);
  const promptApi = useApi(promptApiRef);
  const { profEmail } = authContext;
  const [promptPromotionActivities, setPromptPromotionActivities] =
    React.useState<any[]>([]);
  const [rows, setRows] = React.useState<any[]>([]);
  const [filteredRows, setFilteredRows] = React.useState<any[]>([]);
  const [searchText, setSearchText] = React.useState<string>('');
  const columns = [
    {
      field: 'name',
      headerName: 'Workflow',
      editable: false,
      minWidth: 500,
      flex: 2,
    },
    {
      field: 'prompts',
      headerName: 'Prompts',
      editable: false,
      flex: 2,
    },
    {
      field: 'destination',
      headerName: 'Environment',
      editable: false,
      flex: 1,
    },
    {
      field: 'publishedBy',
      headerName: 'Published by',
      editable: false,
      flex: 1,
    },
    {
      field: 'approvedby',
      headerName: 'Approved by',
      editable: false,
      flex: 1,
    },
    {
      field: 'status',
      headerName: 'Status',
      editable: false,
      flex: 1,
    },
  ];

  useEffect(() => {
    const fetchPromptPromotionActivities = async () => {
      try {
        const response = await promptApi.getPromptPublishQueue();
        if (response) {
          setPromptPromotionActivities(response);
        }
      } catch (error) {
        console.error('Error fetching prompt promotion activities:', error);
      }
    };

    fetchPromptPromotionActivities();
  }, []);

  useEffect(() => {
    if (
      !promptContext.loading &&
      promptContext.prompts?.length > 0 &&
      promptPromotionActivities.length > 0
    ) {
      const mappedRows = promptPromotionActivities.map((item: any) => ({
        id: item.id,
        name: item.name,
        prompts: item.prompt_ids.length,
        promptList: item.prompt_ids.map((p: any) => {
          return promptContext.prompts.find((pr: any) => {
            return pr.id === p
          });
        }),
        destination: item.destination,
        publishedBy: item.email_id.split('@')[0].replace('.', ' '),
        approvedBy: item.email_id.split('@')[0].replace('.', ' '),
        status: item.status,
      }));
      setRows(mappedRows);
      setFilteredRows(mappedRows);
    }
  }, [promptPromotionActivities, promptContext.loading, promptContext.prompts]);

  useEffect(() => {
    if (searchText === '') {
      setFilteredRows(rows);
    } else {
      const filtered = rows.filter((row: any) => {
        console.log(row.name.toLowerCase(), searchText.toLowerCase());
        return row.name.toLowerCase().includes(searchText.toLowerCase());
      });
      setFilteredRows(filtered);
    }
  }, [searchText, rows]);
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const [selectedPrompts, setSelectedPrompts] = React.useState<any[]>([]);

  const handleCellClick = (params: any) => {
    console.log(params.row)
    // if (params.field === 'prompts') {
    //   setSelectedPrompts(params.row.promptList || []);
    //   setDrawerOpen(true);
    // }
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  return (
    <Grid container direction="row">
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <BackButton />
        <HelpComponent helpUrl={HELP_URL.VIEW_PROMPTS} />
      </Grid>
      <Drawer anchor="right" open={drawerOpen} onClose={handleDrawerClose}>
        <div style={{ width: 300, padding: 16 }}>
          <h3>Prompt List</h3>
          <List>
            {selectedPrompts.map((prompt, index) => (
              <ListItem key={index}>
                <ListItemText primary={prompt?.name || 'Unnamed Prompt'} />
              </ListItem>
            ))}
          </List>
        </div>
      </Drawer>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <div className={classes.promptPromotionTableHeading}>
            <h2>Queues ready for publish</h2>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <SearchBar
                onTextChanged={(text: any) => {
                  setSearchText(text);
                }}
              />
            </div>
          </div>
          <div style={{ height: 600, width: '100%' }}>
            <DataGrid columns={columns} rows={filteredRows} pageSize={9} onCellClick={handleCellClick}/>
          </div>
        </Paper>
      </Grid>
    </Grid>
  );
};
